module.exports = __webpack_public_path__ + "static/ExaTest-b9d9fa13cd1952c231c7aa21f6e982fd.svg";